import React from 'react'
import { Link } from 'react-router-dom'
import {Sparkles, Star, ChevronRight, Home} from 'lucide-react'

export function CategoryKids() {
  const kidsShows = [
    {
      id: 1,
      title: 'Morphle Cartoon',
      description: 'Meet the magical red pet that can transform into anything! Perfect for young viewers who love shape-shifting adventures.',
      image: 'https://static.lumi.new/d8/d859fdb4778979e3124cacdf655830a3.png',
      link: '/review/morphle-cartoon',
      keywords: 'cartoon morphle, morphle cartoon, shape-shifting pet'
    },
    {
      id: 2,
      title: 'Magic School Bus',
      description: 'Hop aboard for educational adventures with Ms. Frizzle! Science meets magic in this beloved educational series.',
      image: 'https://images.pexels.com/photos/8613089/pexels-photo-8613089.jpeg?auto=compress&cs=tinysrgb&w=800',
      keywords: 'educational magic, science cartoon'
    },
    {
      id: 3,
      title: 'Little Witch Academia',
      description: 'Follow Akko\'s journey at Luna Nova Magical Academy. A heartwarming tale of friendship and perseverance.',
      image: 'https://images.pexels.com/photos/8923175/pexels-photo-8923175.jpeg?auto=compress&cs=tinysrgb&w=800',
      keywords: 'magic school, young witches'
    }
  ]

  return (
    <div className="min-h-screen bg-gradient-to-b from-pink-50 to-purple-50">
      {/* Navigation */}
      <nav className="bg-white/90 backdrop-blur-sm shadow-md sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center gap-2">
              <Sparkles className="w-8 h-8 text-pink-500" />
              <h1 className="text-2xl sm:text-3xl font-bold bg-gradient-to-r from-pink-500 via-orange-500 to-teal-500 bg-clip-text text-transparent">
                MagicCartoon.com
              </h1>
            </Link>
            <Link 
              to="/" 
              className="flex items-center gap-2 text-gray-600 hover:text-pink-500 font-semibold transition-colors"
            >
              <Home className="w-5 h-5" />
              <span className="hidden sm:inline">Home</span>
            </Link>
          </div>
        </div>
      </nav>

      {/* Header */}
      <section className="bg-gradient-to-r from-red-400 via-pink-400 to-purple-400 py-16 sm:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="flex justify-center mb-4">
            <Star className="w-16 h-16 text-white animate-bounce" />
          </div>
          <h2 className="text-4xl sm:text-5xl font-bold text-white mb-6">
            Kids Magic Cartoons
          </h2>
          <p className="text-xl text-white/90 max-w-3xl mx-auto">
            Age-appropriate magical adventures perfect for young viewers. Safe, educational, and full of wonder!
          </p>
        </div>
      </section>

      {/* Shows Grid */}
      <section className="py-16 sm:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {kidsShows.map((show) => (
              <div 
                key={show.id}
                className="bg-white rounded-2xl overflow-hidden shadow-xl transform hover:scale-105 transition-all duration-300"
              >
                <img 
                  src={show.image}
                  alt={show.title}
                  className="w-full h-64 object-cover"
                />
                <div className="p-6 space-y-4">
                  <h3 className="text-2xl font-bold text-gray-800">{show.title}</h3>
                  <p className="text-gray-600">{show.description}</p>
                  <div className="flex flex-wrap gap-2">
                    {show.keywords.split(', ').map((keyword, idx) => (
                      <span 
                        key={idx}
                        className="bg-pink-100 text-pink-600 px-3 py-1 rounded-full text-sm font-semibold"
                      >
                        {keyword}
                      </span>
                    ))}
                  </div>
                  {show.link ? (
                    <Link 
                      to={show.link}
                      className="group bg-gradient-to-r from-red-500 to-pink-500 text-white px-6 py-3 rounded-full font-semibold hover:shadow-lg transform hover:scale-105 transition-all duration-200 flex items-center gap-2 w-fit"
                    >
                      Read More
                      <ChevronRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
                    </Link>
                  ) : (
                    <button className="group bg-gradient-to-r from-red-500 to-pink-500 text-white px-6 py-3 rounded-full font-semibold hover:shadow-lg transform hover:scale-105 transition-all duration-200 flex items-center gap-2">
                      Coming Soon
                    </button>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  )
}
